import styled from '@emotion/styled'

const PaymentSuccess = () => {
  return (
    <SuccessContainer>
      <SuccessIcon>
        <svg viewBox="0 0 24 24">
          <path
            fill="currentColor"
            d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"
          />
        </svg>
      </SuccessIcon>
      <SuccessTitle>Payment Successful!</SuccessTitle>
      <SuccessMessage>
        Thank you for your purchase. Your payment has been processed
        successfully. A confirmation email has been sent to your registered
        email address.
      </SuccessMessage>
    </SuccessContainer>
  )
}

// Styled components
const SuccessContainer = styled.div`
  max-width: 500px;
  margin: 3rem auto;
  padding: 2rem;
  text-align: center;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
`

const SuccessIcon = styled.div`
  width: 80px;
  height: 80px;
  margin: 0 auto 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #4caf50;
  border-radius: 50%;
  color: white;

  svg {
    width: 48px;
    height: 48px;
  }
`

const SuccessTitle = styled.h2`
  font-size: 1.8rem;
  color: #2e7d32;
  margin-bottom: 1rem;
  font-weight: 600;
`

const SuccessMessage = styled.p`
  font-size: 1.1rem;
  color: #555;
  line-height: 1.6;
  margin: 0 auto;
  max-width: 80%;
`

export default PaymentSuccess
